import React, { useContext, useEffect } from "react";

import { SessionContext } from "@mne-authentication/session2";

import { Routes } from "@mnemonic/router";

import { routeDefinitions } from "./Routes/routeDefinitions";
import initializeLogging from "./utils/initializeLogging";
import { getOpenIdFlowObject } from "./utils/openIdFlowSessionStorage";

const Comp = () => {
  const { session } = useContext(SessionContext);
  useEffect(() => {
    if (session && session.info.authenticationMethod === "OPENID") {
      initializeLogging({ session }).then((logger) => {
        logger.logInfo("openIdFlow", { ...getOpenIdFlowObject() });
      });
    }
  }, []);
  return <Routes context={{ session }} routeDefinitions={routeDefinitions} />;
};

export default Comp;
